import React from 'react';
import PropTypes from 'prop-types';

import {Dropdown, Box, Chip} from '..';

const MultiDropdown = (props) => {
  const children = props.children;

  const labelEntries = React.Children.map(children, (child) => [
    child.props.value,
    child.props.children,
  ]).reduce((prev, cur) => { // this reduce "unflattens" the flat array into object entries
    if (prev.length === 0 || prev[prev.length - 1].length === 2) {
      return [...prev, [cur]];
    } else {
      const [elem] = prev.splice(prev.length - 1, 1);
      return [...prev, [...elem, cur]];
    }
  }, []);

  const labels = Object.fromEntries(labelEntries);
  return (
    <Dropdown
      multiple
      renderValue={(selected) => (
        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
          {selected.map((value) => (
            <Chip key={value} label={labels[value]} />
          ))}
        </Box>
      )}
      {...props}
    />
  );
};


MultiDropdown.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MultiDropdown;
